export function persistedLog(context, details, level = 'log') {
  try {
    const key = 'MSAL_PERSISTED_LOGS';
    const entry = {
      ts: new Date().toISOString(),
      context,
      details,
    };
    const raw = sessionStorage.getItem(key);
    const arr = raw ? JSON.parse(raw) : [];
    arr.push(entry);
    sessionStorage.setItem(key, JSON.stringify(arr));
    const fn = typeof console[level] === 'function' ? console[level] : console.log;
    fn(`PERSIST ${context}:`, details);
  } catch (_err) {
    // no-op
  }
}

export function flushPersistedLogs() {
  try {
    const key = 'MSAL_PERSISTED_LOGS';
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return;
    }
    const arr = JSON.parse(raw);
    console.groupCollapsed('Persisted MSAL logs');
    for (const item of arr) {
      console.log(`[${item.ts}] ${item.context}`, item.details);
    }
    console.groupEnd();
    sessionStorage.removeItem(key);
  } catch (_err) {
    // no-op
  }
}


